import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { HasAnyRoleDirective } from '@core/directives/has-any-role.directive';
import { SETTINGS_HUB_ITEMS, SettingsHubItem } from './settings-hub.config';

@Component({
  selector: 'app-settings-hub',
  standalone: true,
  imports: [CommonModule, HasAnyRoleDirective],
  templateUrl: './settings-hub.component.html',
  styleUrl: './settings-hub.component.scss',
})
export class SettingsHubComponent {
  items: SettingsHubItem[] = SETTINGS_HUB_ITEMS;

  constructor(private router: Router) {}

  open(item: SettingsHubItem): void {
    this.router.navigate(['/configuracoes', item.rota]);
  }
}
